import getDifferenceBetweenDateYearsMonthsDays
  from '@/services/general/getDifferenceBetweenDateYearsMonthsDays';

function getLibelleDureeWithDifference(difference, i18n) {
  let differenceLibelle = difference.years > 0 ? i18n.t('ajoutEditContrat.contrat.duree.year', { nb: difference.years }) : '';
  if (difference.months > 0) {
    differenceLibelle += differenceLibelle ? ' ' : '';
    differenceLibelle += i18n.t('ajoutEditContrat.contrat.duree.mois', { nb: difference.months });
  }
  if (difference.days > 0) {
    differenceLibelle += differenceLibelle ? ' ' : '';
    differenceLibelle += i18n.t('ajoutEditContrat.contrat.duree.jours', { nb: difference.days });
  }
  return differenceLibelle;
}

export default function getDifferenceBetweenDateLibelleYearsMonthsDays(
  dateDebutSend, dateFinSend, i18n,
) {
  const difference = getDifferenceBetweenDateYearsMonthsDays(dateDebutSend, dateFinSend);
  if (!difference) return null;
  return getLibelleDureeWithDifference(difference, i18n);
}
